import React, { useEffect, useState } from 'react';
import { TextField, Typography } from '@material-ui/core';
import { navigate } from '@reach/router';
import { Button, Cards } from 'ams-ui-reactkit';
import { useContextSelector } from '@fluentui/react-context-selector';
import moment from 'moment';
import { TitleBlock } from '../../atoms';
import { TemplateProps } from '../../journeys/journey/Interfaces';
import { StoreContext } from '../../context';
import DynamicHtml from '../../molecules/DynamicHtml';
import { DeleteIcon } from '../../assets/images';
import { actionTypeConstants } from '../../utils';
import './ExtraordinaryDeclaration.scss';
import SignCardWithCheckbox from '../../organisms/SignCardWithCheckbox';
interface Material {
  ItemName: string;
  Quantity: number;
  Price: number;
  Total: number;
}

const ExtraordinaryDeclaration: React.FC<TemplateProps> = (props: any) => {
  const { templateProps } = props;
  const [enableCheckbox, setEnableCheckBox] = useState(false);
  const [enableButton, setEnableButton] = useState(false);
  const [addItem, setAddItem] = useState(false);
  const [isAddItemLoading, setIsAddItemLoading] = useState(false);
  const [customerSignDateText, setCustomerSignDateText] = useState('');
  const [extraordinaryDetails, setExtraordinaryDetails] = useState<Material[]>(
    []
  );
  const [specialItem, setSpecialItem] = useState({
    itemName: '',
    price: '',
    quantity: '',
  });

  const dispatch: any = useContextSelector(
    StoreContext,
    (store) => store?.dispatch
  );
  const customerInfoState: any = useContextSelector(
    StoreContext,
    (store) => store?.appState?.customerInfo
  );
  let geturl = customerInfoState?.Signatureurl[0].getUrl || '';

  const source = customerInfoState?.IsTab;

  useEffect(() => {
    // data is already updating with the api call in prev page
    // getHighValueItemData();
    setExtraordinaryDetails(templateProps?.data?.materials);
  }, []);

  const handleSpecialItemData = (key: any, value: any) =>
    setSpecialItem((prev) => ({ ...prev, [key]: value }));

  
  // const getHighValueItemData = async () => {
  //   try {
  //     const endPoint = `${process.env.REACT_APP_API_ENDPOINT}/getCustomerDetails`;
  //     const response = await fetch(endPoint, {
  //       method: 'POST',
  //       headers: {
  //         'x-api-key': `${process.env.REACT_APP_FVP_API_KEY_DEV}`,
  //         Accept: 'application/json',
  //         'Content-Type': 'application/json',
  //       },
  //       body: JSON.stringify({
  //         CustomerId: customerInfoState?.customerId,
  //         source: parseInt(source),
  //       }),
  //     });
  //     const data = await response.json();

  //     if (data?.FvpJourney?.pages) {
  //       setExtraordinaryDetails(
  //         data.FvpJourney.pages?.ExtraordinaryDeclaration?.templateProps?.data
  //           ?.materials
  //       );
  //       localStorage.setItem('customerInfo', JSON.stringify(data));
  //       dispatch({
  //         type: actionTypeConstants.UPDATE_CUSTOMER_INFO,
  //         payload: { ...data, customerId: localStorage.getItem('CID') },
  //       });
  //     } else {
  //       // setLoading(false);
  //     }
  //   } catch (error) {
  //     console.log('error in getnewdata');
  //   }
  // };

  const handleSubmit = async () => {
    navigate(templateProps?.nextScreen || '/');
  };

  useEffect(() => {
    enableCheckbox ? setEnableButton(true) : setEnableButton(false);
  }, [enableCheckbox]);

  const handleSignClick = () => {
    setEnableCheckBox(!enableCheckbox);
    setCustomerSignDateText(moment().format('MM/DD/YYYY HH:mm A'));
  };

  const createHighValueItem = async () => {
    try {
      setIsAddItemLoading(true);
      const endPoint = `${process.env.REACT_APP_API_ENDPOINT}/createHighValueItem`;
      const response: any = await fetch(endPoint, {
        method: 'POST',
        headers: {
          'x-api-key': `${process.env.REACT_APP_FVP_API_KEY_DEV}`,
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          CustomerId: customerInfoState?.customerId,
          input: {
            name: specialItem?.itemName,
            qty: specialItem?.quantity,
            price: specialItem?.price,
          },
        }),
      });

      const res = await response.json();
      if (res?.status) {
        setExtraordinaryDetails(res?.highValuItems);
        setIsAddItemLoading(false);
        setAddItem(false);
        setSpecialItem({ itemName: '', price: '', quantity: '' });
      }
      console.log('data > createHighValueItem', res);
    } catch (error) {
      setIsAddItemLoading(false);
      console.log('err in createHighValueItem>>', error);
    } finally {
      setIsAddItemLoading(false);
    }
  };

  const deleteHighValueItem = async (itemName: string) => {
    try {
      setExtraordinaryDetails((prev) =>
        prev.filter((item) => item?.ItemName !== itemName)
      );
      const endPoint = `${process.env.REACT_APP_API_ENDPOINT}/deleteHighValueItem`;
      await fetch(endPoint, {
        method: 'POST',
        headers: {
          'x-api-key': `${process.env.REACT_APP_FVP_API_KEY_DEV}`,
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          CustomerId: customerInfoState?.customerId,
          name: itemName,
        }),
      });
    } catch (error) {
      console.log('error in deleting special item', error);
    }
  };

  return (
    <div className="full-block movingProtection">
      <div className="outlineContainer">
        <div className="baseContainerBlock">
          <Cards variant="default">
            <div className="card-block-main">
              {templateProps.title && (
                <TitleBlock title={templateProps.title} />
              )}
              <Typography
                variant="caption"
                color="textPrimary"
                noWrap={false}
                align="center"
                className="color-red full-block pb-16 fw-500"
              >
                <DynamicHtml content={templateProps?.subTitle || ''} />
              </Typography>
              <Typography
                variant="subtitle2"
                variantMapping={{ subtitle2: 'div' }}
                align="left"
                className="fw-400 color-grey"
              >
                <DynamicHtml content={templateProps.content || ''} />
              </Typography>
              <div className="inventory-wrapper">
                {extraordinaryDetails && extraordinaryDetails?.length > 0 ? (
                  <div className="inventory-grid header">
                    <div>Item</div>
                    <div>Price</div>
                    <div>Qty</div>
                    <div>Total</div>
                  </div>
                ) : null}

                {extraordinaryDetails?.map((item: any, index: number) => {
                  return (
                    <React.Fragment key={index.toString() + item?.ItemName}>
                      <div className="inventory-grid row">
                        <div className="detail-div">{item?.ItemName}</div>
                        <div className="detail-div">{item?.Price}</div>
                        <div className="detail-div">{item?.Quantity}</div>
                        <div className="detail-div">{item?.Total}</div>
                        <button
                          onClick={() => deleteHighValueItem(item?.ItemName)}
                          className="delete-btn"
                        >
                          <img
                            alt="deleteicon"
                            style={{ height: 22, width: 22 }}
                            src={DeleteIcon}
                          />
                        </button>
                      </div>
                    </React.Fragment>
                  );
                })}
              </div>

              {!addItem ? (
                <div style={{ margin: 12 }}>
                  <Button
                    onClick={() => {
                      setAddItem(true);
                    }}
                    color="primary"
                    variant="contained"
                    size="large"
                    text={'Add New Item'}
                  />
                </div>
              ) : null}

              {addItem ? (
                <>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-around',
                      margin: 24,
                    }}
                  >
                    <div style={{ margin: 4 }}>
                      <TextField
                        onChange={(e: any) =>
                          handleSpecialItemData('itemName', e.target.value)
                        }
                        value={specialItem?.itemName || ''}
                        type="text"
                        label={'Name'}
                        inputProps={{ style: { fontSize: 16 } }}
                      />
                    </div>
                    <div style={{ margin: 4 }}>
                      <TextField
                        onChange={(
                          e: React.ChangeEvent<
                            HTMLTextAreaElement | HTMLInputElement
                          >
                        ) => {
                          const value = e.target.value;
                          if (parseFloat(value) < 0) {
                            handleSpecialItemData('price', '0');
                          } else {
                            handleSpecialItemData('price', e.target.value);
                          }
                        }}
                        value={specialItem?.price || ''}
                        type="number"
                        label={'Price'}
                        InputProps={{
                          inputProps: { min: 0, style: { fontSize: 16 } },
                        }}
                        onKeyDown={(event) => {
                          if (['-', '+', 'e', 'E'].includes(event.key)) {
                            event.preventDefault();
                          }
                        }}
                      />
                    </div>
                    <div style={{ margin: 4 }}>
                      <TextField
                        onChange={(
                          e: React.ChangeEvent<
                            HTMLTextAreaElement | HTMLInputElement
                          >
                        ) => {
                          const value = e.target.value;
                          if (parseFloat(value) < 0) {
                            handleSpecialItemData('quantity', '0');
                          } else {
                            handleSpecialItemData('quantity', value);
                          }
                        }}
                        onKeyDown={(event) => {
                          if (['-', '+', 'e', 'E'].includes(event.key)) {
                            event.preventDefault();
                          }
                        }}
                        value={specialItem?.quantity || ''}
                        type="number"
                        label={'Quantity'}
                        InputProps={{
                          inputProps: { min: 0, style: { fontSize: 16 } },
                        }}
                      />
                    </div>
                  </div>
                  <Button
                    onClick={() => {
                      createHighValueItem();
                    }}
                    loading={isAddItemLoading}
                    disabled={
                      isAddItemLoading ||
                      !specialItem?.itemName ||
                      !specialItem?.price ||
                      !specialItem?.quantity
                    }
                    color="primary"
                    variant="contained"
                    size="large"
                    text={'Add Item'}
                  />
                </>
              ) : null}

              <div className="mt-16">
                <SignCardWithCheckbox
                  signature={geturl}
                  enable={enableCheckbox}
                  onClick={handleSignClick}
                  signHere={templateProps?.signCard?.signHere || `${customerInfoState?.CustomerName} SIGNED`}
                  signDate={customerSignDateText}
                />
              </div>
            </div>
          </Cards>

          <div className="staticFixedButton">
            <Button
              text={'Continue'}
              onClick={handleSubmit}
              color="primary"
              variant="contained"
              size="large"
              disabled={!enableButton}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExtraordinaryDeclaration;
